module.exports = __webpack_public_path__ + "745e54d6e402d909829196a563fe715d.png";